import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../config/Translate";
import TextField from "@material-ui/core/TextField/TextField";
import validator from "validator";
import axios from "axios";
import {defaultVariabls} from "../../../../config/index";
import Thumbnail from "../../fileManager/Components/Thumbnail";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import LoadingButton from "../../../components/elements/LoadingButton";
import SubTitle from "../../../components/elements/SubTitle";
import AppAnimate from "../../../components/AppAnimate";
import AppCard from "../../../components/layouts/components/AppCard";
import Grid from "@material-ui/core/Grid/Grid";
import {setStore} from "trim-redux";
import BreadCrumbs from "../../../components/elements/BreadCrumbs";
import AppCardLoaderFields from "../../../components/Skeletons/AppCardLoaderFields";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import FieldCounterWithoutBar from "../../../components/elements/FieldCounterWithoutBar";
import Hidden from "@material-ui/core/Hidden/Hidden";
import CurrencyTextField from "@unicef/material-ui-currency-textfield";
import {currencySymbol} from "../../../../config/values";
import SingleImageChooser from "../../fileManager/Components/SingleImageChooser";

class MakePackage extends React.Component {

    constructor(props){
        super(props);
        this.ThumbChild = React.createRef();
        this.EditorChild = React.createRef();

    }
    state = {
        fields:{
            name:"",
            count:"",
            price:'',
            priceR:'',
            discount_price:'',
            discount_priceR:'',
        },
        thumbnail: null,
        errors:{},
        percent:'',
        loading: true,
        SubmitLoading: false,
        id:this.props.match.params.id,
        editMode:false
    };
    classes = this.props.classes;
    async componentDidMount(){
        if(!!this.state.id){
            this.setState({
                editMode:true
            })
            await this.loadData();
        }else{
            this.setState({
                loading:false,
            })
        }
    }
    componentDidUpdate(prevProps){
        if(this.state.id !== this.props.match.params.id){
            this.setState({
                id: this.props.match.params.id
            })
        }
    }
    handleThumbImage(id){
        this.setState({
            thumbnail: id
        })
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/package/get/${this.state.id}`, config)
                .then(response => {
                    this.setState({
                        fields: {
                            name: response.data.name,
                            price: response.data.price,
                            priceR: response.data.price,
                            discount_price: response.data.discount_price,
                            discount_priceR: response.data.discount_price,
                            count: response.data.count,
                        },
                        percent : !!response.data.discount_price > 0 ? Math.max(0, Math.floor((response.data.price - response.data.discount_price)*100/response.data.price)) : '' ,
                        thumbnail: response.data.thumbnail,
                        loading:false,
                    })

                }).catch(error => {
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }
    handleChange(e){
        let {errors,fields,percent} = this.state;
        let target = e.target;
        if(target.name === "price"){
            fields.priceR = target.value.replace(/,/ig, '');
            if(!!fields.discount_priceR)
                percent = Math.max(0, Math.floor((fields.priceR - fields.discount_priceR)*100/fields.priceR));

        }else if (target.name === "discount_price") {
            fields.discount_priceR = target.value.replace(/,/ig, '');
            if(!!fields.priceR)
                percent = Math.max(0, Math.floor((fields.priceR - fields.discount_priceR)*100/fields.priceR));
            if(parseInt(fields.discount_priceR) >= parseInt(fields.priceR)){
                fields.discount_price = '';
                fields.discount_priceR = '';
                percent = ''
            }
        }else{
            fields[target.name] = target.value;
        }
        errors[target.name] = "";
        this.setState({
            fields,
            percent,

        });
    }

    handleValidation(callback){
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;

        //name
        if(validator.isEmpty(fields.name)){
            formIsValid = false;
            errors['name'] = Translate.emptyField;
        }
        if(!fields.count){
            formIsValid = false;
            errors['name'] = Translate.emptyField;
        }

        if(fields.discount_priceR !== null){
            if(fields.discount_priceR > 0){
                if(fields.discount_priceR >= fields.priceR){
                    formIsValid = false;
                    errors['discount_price'] = Translate.discountMoreThanPrice;
                }
            }
        }
        if(!formIsValid){
            this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                variant: 'warning',
            });
            this.setState({
                errors,
                SubmitLoading:false,
            })
        }
        return callback(formIsValid)
    }
    handleRequest(){
        let { fields,id,editMode,thumbnail} = this.state;
        let data = new FormData();
        data.append('name', fields.name);
        data.append('count', fields.count);
        data.append('id', id ? id : 0);
        data.append('price', fields.priceR);
        data.append('discount_price', fields.discount_priceR);
        data.append('thumbnail', !!thumbnail ? thumbnail.id : '');

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/package/make`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(editMode ? Translate.dataEdited : Translate.dataAdded, {
                    variant: 'success',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                    SubmitDraftLoading: false
                });
                if(!this.state.editMode){
                    this.props.history.push(`/manage/packages`);
                }
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(editMode ?  Translate.dataEditingFailed : Translate.dataAddingFailed, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                    SubmitDraftLoading: false
                });
            });

    }
    handleSubmit(e){
        this.setState({
            SubmitLoading: true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }
        });
    }
    handleChangePercent(e){
        let percent = e.target.value;
        let fields = this.state.fields;
        let price = this.state.fields.priceR;
        if(!!price){
            fields['discount_priceR'] = price - (price*percent/100);
            fields['discount_price'] = price - (price*percent/100);
        }
        if(parseInt(percent) === 0){
            fields.discount_price = '';
            fields.discount_priceR = '';
            percent = ''
        }
        this.setState({
            percent,
            fields
        })
    }
    render(){
        let {fields, errors,SubmitLoading,thumbnail,editMode,percent} = this.state;
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={editMode ? Translate.editPackage : Translate.makePackage}>
                {

                    <Grid container spacing={2} justify="center">
                        <Grid item xs={12} md={8} lg={9}>
                            <AppCard
                                title={editMode ? Translate.editPackage : Translate.makePackage}
                                action={
                                    <BreadCrumbs singleLevel firstText={editMode ? Translate.editPackage : Translate.makePackage}/>
                                }>
                                {
                                    this.state.loading ? <AppCardLoaderFields/> :
                                        <Grid container spacing={2} justifyContent="center" alignItems="center">
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    margin="normal"
                                                    required
                                                    fullWidth
                                                    variant="outlined"
                                                    name="name"
                                                    label={Translate.packageName}
                                                    type="text"
                                                    id="name"
                                                    value={fields.name}
                                                    onChange={this.handleChange.bind(this)}
                                                    error = {!!errors['name']}
                                                    helperText={errors['name']}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    margin="normal"
                                                    required
                                                    fullWidth
                                                    variant="outlined"
                                                    name="count"
                                                    label={Translate.product_quantity}
                                                    type="number"
                                                    value={fields.count}
                                                    onChange={this.handleChange.bind(this)}
                                                    error = {!!errors['count']}
                                                    helperText={errors['count']}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6} >
                                                <CurrencyTextField
                                                    variant="outlined"
                                                    fullWidth
                                                    required
                                                    currencySymbol={currencySymbol}
                                                    decimalPlaces={0}
                                                    value={fields.price}
                                                    id="price"
                                                    label={Translate.price}
                                                    name="price"
                                                    onChange={this.handleChange.bind(this)}
                                                    error = {!!errors['price']}
                                                    helperText={errors['price']}
                                                />
                                            </Grid>
                                            <Grid item xs={4} md={2}>
                                                <TextField
                                                    variant="outlined"
                                                    value={percent}
                                                    fullWidth
                                                    id="percent"
                                                    label={Translate.discount_percent}
                                                    name="percent"
                                                    autoComplete="percent"
                                                    onChange={this.handleChangePercent.bind(this)}
                                                    error = {!!errors['percent']}
                                                    helperText={errors['percent']}
                                                    InputProps={{
                                                        startAdornment: <InputAdornment position="start">%</InputAdornment>,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={8} md={4}>
                                                <CurrencyTextField
                                                    variant="outlined"
                                                    fullWidth
                                                    currencySymbol={currencySymbol}
                                                    decimalPlaces={0}
                                                    value={fields.discount_price}
                                                    id="discount_price"
                                                    label={Translate.discount_price}
                                                    name="discount_price"
                                                    onChange={this.handleChange.bind(this)}
                                                    error = {!!errors['discount_price']}
                                                    helperText={errors['discount_price']}
                                                />
                                            </Grid>

                                            <Hidden smDown>
                                                <Grid item xs={12}>
                                                    <LoadingButton
                                                        variant="contained"
                                                        color="primary"
                                                        onClick = {this.handleSubmit.bind(this)}
                                                        loading = {SubmitLoading}
                                                    >
                                                        {editMode ? Translate.editPackage : Translate.makePackage}
                                                    </LoadingButton>
                                                </Grid>
                                            </Hidden>
                                        </Grid>
                                }
                            </AppCard>
                        </Grid>
                        <Grid item xs={12} md={4} lg={3}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <AppCard>
                                        {
                                            this.state.loading ? <AppCardLoaderFields/> :
                                                <Grid container spacing={2} alignItems="center">
                                                    <Grid item xs={12}>
                                                        <SubTitle>{Translate.thumbnail}</SubTitle>
                                                        <SingleImageChooser
                                                            primary
                                                            onChange={(thumbnail) => this.handleThumbImage(thumbnail)}
                                                            initial={thumbnail}
                                                        />
                                                    </Grid>
                                                </Grid>
                                        }
                                    </AppCard>
                                </Grid>
                                <Hidden mdUp>
                                    <Grid item xs={12}>
                                        <LoadingButton
                                            variant="contained"
                                            color="primary"
                                            onClick = {this.handleSubmit.bind(this)}
                                            loading = {SubmitLoading}
                                        >
                                            {editMode ? Translate.editPackage : Translate.makePackage}
                                        </LoadingButton>
                                    </Grid>
                                </Hidden>
                            </Grid>

                        </Grid>
                    </Grid>
                }
            </AppAnimate>

        );
    }
}

export default withSnackbar(withRouter(withStyles(Styles)(MakePackage)));